import { pm2ConfigStore } from '@pm2/store';
import { makeTanstackQuery } from '@provider/tanstack';
import { useUserIdentityState } from '@provider/user-identity';
import { configRefs, DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { getFavouritesRequest } from './get-favourties.request.js';

const getFavouritesQuery = makeTanstackQuery({
  defaultQueryConfig: {
    staleTime: 24 * HOURS_TO_MS,
    gcTime: 21 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  },
  queryKey: input => ["user-area/favourites/get", configRefs.env.app.dangerouslyAssertSyncValue(), input.portalId, input.user?.id],
  queryFn: input => {
    if (!input.user) {
      return null;
    }
    return getFavouritesRequest(input.configStore.getState().config, input.user);
  },
  useQueryInput(queryFactory) {
    const user = useUserIdentityState(state => state.user);
    const configStore = pm2ConfigStore.useStore();
    const portalId = configStore.useSelector(state => state.config.id);
    return queryFactory({
      user,
      configStore,
      portalId
    });
  }
});

export { getFavouritesQuery };
//# sourceMappingURL=get-favourites.query.js.map
